import { render, staticRenderFns } from "./DifferentialExpressionTable.vue?vue&type=template&id=53719f80&scoped=true"
import script from "./DifferentialExpressionTable.vue?vue&type=script&lang=js"
export * from "./DifferentialExpressionTable.vue?vue&type=script&lang=js"
import style0 from "./DifferentialExpressionTable.vue?vue&type=style&index=0&id=53719f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53719f80",
  null
  
)

export default component.exports